module.exports = __webpack_public_path__ + "img/6.3b6b052c.png";